module.exports = __webpack_public_path__ + "static/media/purple.92400d96.png";